export const ALL_CASES = '1';
export const OPEN_CASES = '2';
export const REPORTED_CASES = '3';